<template>
  <div
    id="CropSlider"
    @keydown.stop="() => {}"
  >
    <el-tabs
      tab-position="left"
      v-model="activeName"
      class="customViewTabChange"
      @tab-click="tabChange"
    >
      <!-- First tab about source -->
      <el-tab-pane name="first">
        <!-- 左tab -->
        <div slot="label" class="title">
          <p><i class="iconfont icon-a-Lband1"></i></p>
          <p class="titleLabel">{{ $t('lang.type') }}</p>
        </div>
        <!-- 右内容 -->
        <div class="CropVideo">
          <!-- 列表展示 -->
          <div class="pipSourceList scrollCss">
            <h2>{{ $t('lang.ChooseSqueezeType') }}</h2>
            <!-- 四个方向 -->
            <ul class="clearfix">
              <li
                class="fl typeBox"
                v-for="(item, index) in lBandTypeList"
                :key="index"
                :class="{active: OtherParame.squeezeType === item.type}"
                @click="changeLBandType(item)"
              >
                <img
                  class="lBandType"
                  :src="lbanImgObj[index+1]"
                  alt="lBandImage"
                />
              </li>
            </ul>
            <div>
              <h2 class="editTitle">
                {{ $t('lang.EditTransition') }}
              </h2>
              <!-- 用户自定义宽高坐标 -->
              <div class="position">
                <!-- Width & Height -->
                <div class="width_height top">
                  <div class="fl">
                    <p class="name">{{ $t('lang.width') }}</p>
                    <el-input
                      v-model.number="position.width"
                      type="number"
                      @change="updateSourcePosition('w', position.width)"
                    ></el-input>
                  </div>
                  <i class="iconfont iconlink"></i>
                  <div class="fr">
                    <p class="name">{{ $t('lang.height') }}</p>
                    <el-input
                      v-model.number="position.height"
                      type="number"
                      @change="updateSourcePosition('h', position.height)"
                    ></el-input>
                  </div>
                </div>
              </div>
              <p class="chooseTitle">{{ $t('lang.SqueezeInOut') }}</p>
              <div class="squeezeTime">
                <el-input
                  :placeholder="$t('lang.pleaseInput30')"
                  v-model.number="OtherParame.squeezeTime"
                  @change="squeezeBlur"
                >
                  <template slot="append">ms</template>
                </el-input>
              </div>
              <p class="chooseTitle">{{ $t('lang.EffectDuration') }}</p>
              <div class="squeezeTime">
                <el-input
                  :placeholder="$t('lang.pleaseInput1')"
                  v-model.number="OtherParame.effectDuration"
                  @change="durationBlur"
                >
                  <template slot="append">s</template>
                </el-input>
              </div>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <!-- Second tab Background -->
      <el-tab-pane name="second">
        <!-- 左tab上传 -->
        <div slot="label" class="title">
          <p><i class="iconfont icon-beijing"></i></p>
          <p class="titleLabel">{{ $t('lang.Background') }}</p>
        </div>
        <!-- 右内容 -->
        <div class="CropBackground">
          <!-- 列表展示 -->
          <div class="bg-img" v-if="!showBgUrl" >
            <p>
              {{ $t('lang.Background') }} ({{ $t('lang.size') }}: {{UploadConfig.HeightLimitWidth.width}}*{{UploadConfig.HeightLimitWidth.height}})
            </p>
            <!-- 上传图片按钮和弹框 -->
            <div class="upload-bgc">
              <el-button
                class="addLogoBtn"
                type="primary"
                @click="changeBg"
              >
                <i class="iconfont iconAdd"></i>
                {{ $t('lang.Add') }}
              </el-button>
            </div>
            <ul class="BackgroundList" v-scroll="LBandBackScroll" v-loading="loadedImg" >
              <li
                class="single-file"
                v-for="(file, index) in BackgroundList"
                :key="index"
                @click="setBg(file)"
              >
                <div
                  class="backContainer loaded-file"
                  :class="{ greenBorder: file.url == OtherParame.url}"
                >
                  <div class="img-contianer">
                    <div
                      class="backgroundBox"
                      v-if="/.*(\.png|\.jpg|\.jpeg|\.gif|\.PNG|\.JPG|\.JPEG|\.GIF)$/g.test(file.url)"
                      :style="`width: 100%;height: 100%;backgroundImage:url(${file.url || imgUrl})`"
                    ></div>
                    <iframe
                      v-else
                      :src="`${file.url || imgUrl}`"
                      frameborder="0"
                      style="width:1920px;height:1080px;transform-origin: 0 0; transform: scale(0.1333); "
                    ></iframe>
                    <div
                      class="backgroundBoxModal"
                      :class="{active: file.url == OtherParame.url}"
                    ></div>
                  </div>
                  <div
                    class="operationParent"
                    v-if="file.url !== OtherParame.url"
                  >
                    <div
                      @click.stop="deleteback(file,index)"
                      class="remove"
                      slot="reference"
                    >
                      <i class="iconfont icon-icon14"></i>
                    </div>
                  </div>
                  <div
                    class="bottom-bar"
                    :title="file.url"
                  >
                    <div class="left">{{ file.url }}</div>
                  </div>
                </div>
                <!--<p
                  class="fileTootip"
                  v-show="lBandInfo.backgroundUrl === file.sourceValue"
                >{{ $t('lang.fileTooltips') }}
                </p>-->
              </li>
            </ul>
          </div>
          <!-- 上传 -->
          <div v-else >
            <h2 class="sliderHeader">
              <i
                class="iconfont icon-fanhui"
                @click="tabChange"
              ></i>
              Back
            </h2>
            <LBandBackground
              :awsInfo="awsInfo"
              :OwnerUserid="OwnerUserid"
              :UploadConfig="UploadConfig"
              :programId="programId"
              @ExternalLinkAdd="ExternalLinkAdd"
            >
            </LBandBackground>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Bus from '@/assets/js/vueBus.js'
import cloneDeep from 'lodash/cloneDeep'
import LBandBackground from './LBandBackground'
import Outil from '@/assets/js/utils.js'
import toTips from '@/assets/js/toTipsObj'

export default {
  name: 'LBandSlider',
  props: {
    // 编辑的lBand信息
    lBandInfo: {
      type: Object,
      default: () => ({})
    },
    // 所选分辨率
    VideoResolution: {
      type: Object,
      default: () => ({
        width: 1920,
        height: 1080
      })
    }
  },
  data () {
    return {
      // tab切换
      activeName: 'first',
      imgUrl: require('./quad-default.png'),
      // lband具体位置
      position: {
        x: 1152,
        y: 0,
        width: 768,
        height: 432
      },
      // 其他参数
      OtherParame: {
        // 动画进入离开时间
        squeezeTime: 500,
        // 持续时间
        effectDuration: 10,
        // 方向类型
        squeezeType: 0,
        // 背景图fileid
        fileId: '',
        // 背景图
        url: ''
      },
      scale: 1.7777777777777777,
      // 背景加载
      loadedImg: false,
      // 背景上传开关
      showBgUrl: false,
      // 背景列表
      BackgroundList: [],
      // 背景图片
      BackgroundImage: [],
      // 外链地址列表
      ExternalLink: [],
      // 四个方向的选择
      lBandTypeList: [
        {
          x: 1152,
          width: 768,
          y: 0,
          height: 432,
          type: 0
        },
        {
          x: 0,
          width: 768,
          y: 0,
          height: 432,
          type: 2
        },
        {
          x: 1152,
          width: 768,
          y: 648,
          height: 432,
          type: 1
        },
        {
          x: 0,
          width: 768,
          y: 648,
          height: 432,
          type: 3
        }
      ],
      lbanImgObj: {
        1: require('@/assets/images/lband/Lband2.png'),
        2: require('@/assets/images/lband/Lband1.png'),
        3: require('@/assets/images/lband/Lband4.png'),
        4: require('@/assets/images/lband/Lband3.png')
      },
      // 分辨率
      extraData: {},
      // aws信息
      awsInfo: {},
      // 获取Owner
      OwnerUserid: '',
      // channel 主id
      programId: '',
      // 上传配置
      UploadConfig: {
        // 上传格式
        accept: '.jpg,.jpeg,.png,.gif',
        // 支持格式提示
        supportFormat: '.jpg,.jpeg,.png,.gif',
        // 上传文件夹
        UploadFolder: '/PLAYOUT/LBandBackground',
        // 宽高限制
        HeightLimitWidth: {
          width: this.VideoResolution.width,
          height: this.VideoResolution.height
        }
      },
      // 绑定滚动事件
      LBandBackScroll: {
        onScroll: this.getLBandList,
        distance: 10
      }
    }
  },
  components: {
    LBandBackground
  },
  created () {
    Bus.$on('goBgTab', this.goBgTab)
    this.position = {
      x: this.lBandInfo.x,
      y: this.lBandInfo.y,
      width: this.lBandInfo.width,
      height: this.lBandInfo.height,
      id: this.lBandInfo.id
    }
    this.OtherParame = {
      squeezeTime: this.lBandInfo.squeezeTime,
      effectDuration: this.lBandInfo.effectDuration,
      squeezeType: this.lBandInfo.squeezeType,
      fileId: this.lBandInfo.fileIdx,
      url: this.lBandInfo.url
    }
    if (!this.lBandInfo.fileId && this.lBandInfo.url) {
      this.ExternalLink.push({
        url: this.lBandInfo.url
      })
    }
  },
  mounted () {
    Bus.$on('draggable-Source', this.draggableSource)
    this.awsInfo = this.$BehaviorSyns.getRegionBucket()
    this.OwnerUserid = Outil.getProgramReceiver('ownerUserId')
    this.programId = this.$BehaviorSyns.getProgramId()
    this.getBackgroundList()
    this.getSourcePosition(this.position)
    this.getVideoResolution()
  },
  methods: {
    tabChange () {
      if (this.showBgUrl) {
        this.showBgUrl = false
        this.getBackgroundList()
      }
    },
    // 显示当前source的坐标
    getSourcePosition (value) {
      const position = cloneDeep(value)
      if (value.width > this.VideoResolution.width) this.position.width = this.VideoResolution.width
      if (value.height > this.VideoResolution.height) this.position.height = this.VideoResolution.height
      this.position = position
      // this.scale = value.width / value.height
    },
    /**
     * @description: 在slider bar输入w,h,x,y后变更画布上source的大小
     * @param {String} name w,h,x,y
     * @param {Number} value
     * @return {*}
     */
    // 修改宽高同步画布
    updateSourcePosition (name, value) {
      if (name == 'w' && value > this.VideoResolution.width) {
        value = this.VideoResolution.width
        this.position.width = this.VideoResolution.width
      }
      if (name == 'h' && value > this.VideoResolution.height) {
        value = this.VideoResolution.height
        this.position.height = this.VideoResolution.height
      }
      const pictureInfo = cloneDeep(this.position)
      const halfW = Number((pictureInfo.width / 2).toFixed(0))// 当前source宽度的一半
      const halfH = Number((pictureInfo.height / 2).toFixed(0)) // 当前source高度的一半
      const halfX = this.VideoResolution.width / 2
      const halfY = this.VideoResolution.height / 2
      // 输如每个值都要去变更一下source的长宽高以及坐标，坐标以source的中心为原点，传给后台时按照左上角为原点
      switch (name) {
        case 'w':
          this.position.height = pictureInfo.height = Number((value / this.scale).toFixed(0))
          if (this.OtherParame.squeezeType === 3) {
            pictureInfo.x = 0
            pictureInfo.y = this.VideoResolution.height - pictureInfo.height
          } else if (this.OtherParame.squeezeType === 2) {
            pictureInfo.x = 0
            pictureInfo.y = 0
          } else if (this.OtherParame.squeezeType === 0) {
            pictureInfo.x = this.VideoResolution.width - value
            pictureInfo.y = 0
          } else {
            pictureInfo.x = this.VideoResolution.width - value
            pictureInfo.y = this.VideoResolution.height - pictureInfo.height
          }
          break
        case 'h':
          this.position.width = pictureInfo.width = Number((value * this.scale).toFixed(0))
          if (this.OtherParame.squeezeType === 3) {
            pictureInfo.x = 0
            pictureInfo.y = this.VideoResolution.height - value
          } else if (this.OtherParame.squeezeType === 2) {
            pictureInfo.x = 0
            pictureInfo.y = 0
          } else if (this.OtherParame.squeezeType === 0) {
            pictureInfo.x = this.VideoResolution.width - pictureInfo.width
            pictureInfo.y = 0
          } else {
            pictureInfo.x = this.VideoResolution.width - pictureInfo.width
            pictureInfo.y = this.VideoResolution.height - value
          }
          break
        case 'x':
          pictureInfo.x = value + halfX - halfW
          pictureInfo.y = halfY - pictureInfo.y - halfH
          break
        case 'y':
          pictureInfo.y = halfY - value - halfH
          pictureInfo.x = pictureInfo.x + halfX - halfW
      }
      if (pictureInfo.x < 0 || pictureInfo.y < 0) {
        this.$message.error(this.$t('lang.onlyCanvas'))
        return
      }
      this.position = cloneDeep(pictureInfo)
      Bus.$emit('updateLBandCanvas', {
        type: 'position',
        ...this.position,
        squeezeType: this.OtherParame.squeezeType
      })
    },
    // 拖拽参数处理
    draggableSource (data) {
      if (data.type == 'focus') {
        this.activeName = 'first'
      } else if (data.type == 'change') {
        this.getSourcePosition(data)
      }
    },
    // 四个方向的选择
    changeLBandType (item) {
      if (!this.position.width || !this.position.width) this.position = cloneDeep(item)
      const width = this.position.width
      const height = this.position.height
      this.OtherParame.squeezeType = item.type
      if (item.type === 3) {
        this.position.x = 0
        this.position.y = this.VideoResolution.height - height
      } else if (item.type === 2) {
        this.position.x = 0
        this.position.y = 0
      } else if (item.type === 0) {
        this.position.x = this.VideoResolution.width - width
        this.position.y = 0
      } else if (item.type === 1) {
        this.position.x = this.VideoResolution.width - width
        this.position.y = this.VideoResolution.height - height
      }
      Bus.$emit('updateLBandCanvas', {
        type: 'position',
        ...this.position,
        squeezeType: this.OtherParame.squeezeType
      })
    },
    // 打开背景上传
    changeBg () {
      this.showBgUrl = true
      this.url = ''
    },
    // 失去焦点提示
    durationBlur (value) {
      if (value < 1 || !/(\d+)/g.test(value)) {
        this.$message.error(this.$t('lang.pleaseInput1'))
      }
    },
    // 失去焦点提示
    squeezeBlur (value) {
      if (value < 30 || !/(\d+)/g.test(value)) {
        this.$message.error(this.$t('lang.pleaseInput30'))
      }
    },
    goBgTab () {
      this.activeName = 'second'
    },
    // 删除背景
    deleteback (file, index) {
      if (!file.id) {
        this.ExternalLink.splice(index, 1)
        this.BackgroundList = [...this.ExternalLink, ...this.BackgroundImage]
        return
      }
      this.loadedImg = true
      const url = '/L-Band/lBandUsed'
      this.axios
        .post(Outil.getUrl(url), {
          fileId: file.id,
          programId: this.programId
        })
        .then(res => {
          if (res.data.errorCode == '0x0') {
            this.getBackgroundList()
          } else {
            this.loadedImg = false
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        })
        .catch(() => {
          this.loadedImg = false
        })
    },
    // 设置背景图片
    setBg (item) {
      this.OtherParame.fileId = item.id
      this.OtherParame.url = item.url
      Bus.$emit('updateLBandCanvas', {
        type: 'background',
        url: this.OtherParame.url
      })
    },
    // 获取背景图片
    getBackgroundList () {
      this.loadedImg = true
      this.axios.post(Outil.getUrl('/L-Band/getLBandImages'), {
        programId: this.programId
      }).then((res) => {
        const { errorCode } = res.data
        if (errorCode === '0x0') {
          this.BackgroundImage = res.data.result
          this.BackgroundList = [...this.ExternalLink, ...this.BackgroundImage]
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
        this.loadedImg = false
      }).catch(() => {
        this.loadedImg = false
      })
    },
    // 外链添加
    ExternalLinkAdd (url) {
      this.ExternalLink.push({
        url: url
      })
      this.BackgroundList = [...this.ExternalLink, ...this.BackgroundImage]
    },
    // 获取分辨率
    getVideoResolution () {
      this.axios
        .post(Outil.getUrl('/program/getVideoResolution'), {
          programId: this.programId
        })
        .then(res => {
          if (res.data.errorCode == '0x0') {
            const HeightLimitWidth = {
              width: res.data.result.width,
              height: res.data.result.height
            }
            this.UploadConfig.HeightLimitWidth = HeightLimitWidth
          } else {
            const errorInfo =
              this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
          }
        })
        .catch(() => {
        })
    }
  },
  beforeDestroy () {
    Bus.$off('draggable-Source')
    Bus.$off('goBgTab')
  }
}
</script>
<style lang="less" scoped>
#CropSlider {
  float: left;
  height: calc(100% - 64px);
  background: #111213;
  z-index: 2;
  position: absolute;
  p {
      margin: 0;
      line-height: 1;
  }
  .title {
    text-align: center;
    .icon-a-Lband1 {
      font-size: 25px;
      color: #dedede;
      line-height: 30px;
    }
    .icon-beijing{
      font-size: 30px;
      color: #dedede;
    }
  }
  ::v-deep.customViewTabChange {
      height: 100%;
    .el-tabs__header {
      width: 96px;
      margin-right: 0;

      .el-tabs__item {
        height: 62px;
        padding: 0;
        margin-top: 20px;

        .titleLabel {
          line-height: 0;
          text-align: center;
          margin-top: 10px;
        }
      }
    }

    .el-tabs__active-bar {
      background: #181a1c;
    }

    .el-tabs__item.is-active {
      .iconfont {
        color: #fff;
      }
      color: #fff;
    }

    .el-tabs__nav-wrap.is-left::after {
      background: #181a1c;
    }

    .el-tabs__content {
      width: 288px;
      height: 100%;
      background: rgba(36, 38, 40, 1);

      .el-tab-pane {
        height: 100%;
      }
    }
  }
  .iconbeijing {
    font-size: 40px;
    color: rgba(255, 255, 255, 0.49);
    display: block;
  }

  .CropVideo {
    height: 100%;
    padding-left: 20px;

    h2 {
      height: 24px;
      margin-top: 18px;
      font-size: 18px;
      font-weight: 600;
      color: rgba(149, 149, 149, 1);
      margin-bottom: 18px;

      &.editTitle {
        margin-top: 0;
      }
    }

    .chooseTitle {
      height: 18px;
      color: #fff;
      font-size: 14px;
      margin-bottom: 10px;
    }

    .pipSourceList {
      height: calc(100% - 55px);
      width: 100%;
      overflow: hidden;
      overflow-y: auto;

      ul {
        margin-top: 20px;
        margin-right: 15px;

        li {
          margin-bottom: 20px;
        }

        .name {
          padding-left: 5px;
          line-height: 40px;
          position: absolute;
          left: 0;
          bottom: 4px;
          font-size: 14px;
          color: #fff;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.8) 100%
          );
        }
      }
    }
  }

  .CropBackground {
    height: 100%;
    padding: 10px 12px;

    h2 {
      margin-top: 18px;
      font-size: 18px;
      font-weight: 600;
      color: rgba(149, 149, 149, 1);

      &.sliderHeader {
        color: #fff;
      }
    }

    .bg-img {
      height: 100%;
      p {
        font-size: 14px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        padding-top: 7px;
        padding-bottom: 8px;
      }

      .img-contianer {
        position: absolute;
        width: 256px;
        height: 144px;
        background: #000;
        background-repeat: no-repeat !important;
        background-size: contain;
        background-position-x: center;
        background-position-y: center;

        img {
          max-width: 100%;
          max-height: 100%;
        }

        .upload-transition {
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          text-align: center;
          line-height: 144px;
          object-fit: contain;

          .upload-btn {
            border-radius: 4px;
            border: 2px solid rgba(93, 192, 69, 1);
            width: 152px;
            height: 28px;
            color: #fff;
          }
        }
      }
    }
  }
  .position {
    .name {
      font-size: 14px;
      color: #fff;
      margin-bottom: 10px;
    }

    .top {
      height: 73px;
    }

    .iconlink {
      font-size: 14px;
      color: #fff;
      margin-top: 38px;
      float: left;
      margin-left: 7px;
    }

    .fr {
      margin-right: 47px;
    }

    ::v-deep .el-input {
      width: 96px;

      input {
        width: 96px;
        height: 32px;
        border: 0;
        color: #fff;
        background: rgba(49, 52, 54, 1);
        border-radius: 2px;
      }
    }

    margin-bottom: 15px;
  }
  ::v-deep input,
  .el-input__inner {
    height: 32px;
    color: #fff;
    border: 0;
    border-radius: 2px;
    background-color: #313436;
  }
  .addLogoBtn {
    color: #5dc045;
    font-size: 12px;
    font-weight: 600;
    width: 100%;
    background: rgba(49, 52, 54, 1);
    border-color: rgba(49, 52, 54, 1);
    display: block;
    margin-bottom: 12px;

    i {
      font-size: 12px;
      font-weight: 600;
    }
  }
}

::v-deep .el-input.is-disabled .el-input__inner {
  background-color: #313436;
}

::v-deep .el-input__icon {
  line-height: 32px;
}

.lBandType {
  float: left;
  width: 100px;
  height: 75px;
}

.typeBox {
  width: 100px;
  height: 75px;
  margin-bottom: 20px;
  background-color: #5dc045;
  margin-right: 12px;
  box-sizing: border-box;

  img {
    width: 100%;
    height: 100%;
  }

  &.active {
    padding: 2px;

    img {
      border: solid #000 3px;
    }
  }
}

.doneBtn {
  margin-top: 20px;
  margin-right: 12px;
}

.squeezeTime {
  padding-right: 20px;
  margin-bottom: 10px;

  ::v-deep .el-input-group__append {
    background: #313436;
    border: none;
    padding: 0 10px;
  }

  ::v-deep .el-input__inner {
    padding-right: 0;
  }
}

.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat !important;
  background-size: contain;
  background-position-x: center;
  background-position-y: center;
}

.backgroundBox {
  background-repeat: no-repeat !important;
  background-size: contain;
  background-position-x: center;
  background-position-y: center;
}

.iconArrowLeft {
  cursor: pointer;
}

.backgroundTip {
  color: #7c7c7c;
  font-size: 12px;
}
.BackgroundList {
  height: calc(100% - 95px);
  overflow: auto;
  .single-file {
    color: #fff;
    position: relative;
    width: 100%;
    display: inline-block;
    overflow: hidden;

    &:hover {
      .remove,
      .edit,
      .fileTootip {
        display: block;
      }
    }

    .fileTootip {
      left: 50px;
      top: 70px;
      position: absolute;
      width: 210px;
      border-radius: 4px;
      height: 48px;
      padding: 5px;
      z-index: 200;
      font-size: 12px;
      background: #303133;
      display: none;
      word-break: break-word;
    }

    &.active {
      background: rgba(88, 91, 93, 1);
    }

    .greenBorder {
      border: 2px solid #5dc045;
    }

    .operationParent {
      position: absolute;
      right: 0;
      top: 0;
    }

    .remove {
      display: none;
      float: right;
      z-index: 3;
      width: 34px;
      height: 34px;
      line-height: 34px;
      font-size: 18px;
      cursor: pointer;
      text-align: center;
      background: rgba(246, 68, 90, 1);
    }

    .backContainer {
      width: 256px;
      height: 144px;
      background-size: cover;
      background-color: #000;
      text-align: center;
      box-sizing: content-box;

      &.loaded-file {
        position: relative;
        /*background-image: url('./no_image.png');*/
        display: flex;
        align-items: flex-end;
        cursor: pointer;
        .bottom-bar {
          position: absolute;
          width: 100%;
          height: 40px;
          font-size: 12px;
          font-weight: 600;
          line-height: 40px;
          padding: 0 6px;
          background: linear-gradient(
            180deg,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.8) 100%
          );

          div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .left {
            float: left;
            text-align: left;
            margin-left: 5px;
            width: 150px;
          }

          .right {
            float: right;
            text-align: right;
          }
        }
      }

      &.RDownloading {
        opacity: 0.5;
      }
    }
  }
}

.backgroundBoxModal {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  &.active {
    border: solid #5dc045 2px;
  }
}

.iconBack {
  cursor: pointer;
}
</style>
